module.exports = __webpack_public_path__ + "media/src/images/icons/oval_7x-ba13cca5043d3bf1a99f84c0cdf6c2e4.png";